<template>
    <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="false" custom-class="custom"
               :show-close="false" width="1161">
        <div class="wxBox">
            <div class="wxchatBorderLeft" ref="chartLeft">
                <div ref="chartLeftMsg">
                    <div class="wxSearch">
                        <el-input
                            @change="searchName"
                            placeholder="搜索名称"
                            prefix-icon="el-icon-search"
                            v-model="searchIn">
                        </el-input>
                    </div>
                    <el-row  v-if="searchData.length > 0">
                        <div v-for="(item ,index) in searchData" @click="changeTarget(item.uuid, item.name,item.headUrl,index,'')">
                            <el-col :span="24"
                                    :class="item.uuid === targetUserId?'currentObj conversationClass':'conversationClass'">
                                <div style="padding: 12px;" class="avatarUser">
                                    <el-avatar shape="square" :src="item.headUrl"  style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </div>
                                <div class="wxchatPeopleBox">
                                    <div class="wxchatPeople">
                                        <el-col style="font-size:14px;max-width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                            {{ item.name }}
                                        </el-col>
                                        <div class="wxchatPeopleTime">
                                          {{ item.lastUnreadTime }}
                                        </div>
                                    </div>
                                  <div class="wxchatPeopleMess">
                                    <p class="wxchatPeopleMess_con">{{ item.latestMessage }}</p>
                                    <p class="wxchatPeopleMess_num" v-if="item.unreadMessageCount > 0">{{ item.unreadMessageCount }}</p>
                                  </div>
    
                                </div>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row v-else>
                        <div v-for="(item ,index) in conversationList" @click="changeTarget(item.uuid, item.name,item.headUrl,index,'')">
                            <el-col :span="24"
                                    :class="item.uuid === targetUserId?'currentObj conversationClass':'conversationClass'">
                                <div style="padding: 12px;" class="avatarUser">
                                    <el-avatar shape="square" :src="item.headUrl"  style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </div>
                                <div class="wxchatPeopleBox">
                                    <div class="wxchatPeople">
                                        <el-col style="font-size:14px;max-width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                            {{ item.name }}
                                        </el-col>
                                        <div class="wxchatPeopleTime">
                                          {{item.lastUnreadTime?item.lastUnreadTime:moment(new Date()).format('YYYY/MM/DD')}}
                                        </div>
                                    </div>
                                    <div class="wxchatPeopleMess">
                                        <p class="wxchatPeopleMess_con">{{ item.latestMessage }}</p>
                                        <p class="wxchatPeopleMess_num" v-if="item.unreadMessageCount > 0">{{ item.unreadMessageCount }}</p>
                                    </div>
    
                                </div>
                            </el-col>
                        </div>
                    </el-row>
                </div>
            </div>
            <div>
                <div class="wxchatBorderRightTop">
                    <div class="closeButton" @click="cancel">
                        <i class="el-icon-close" style="font-size: 20px;"></i>
                    </div>
                    <div class="wxchatName" v-text="targetUserName"></div>
                </div>
                <div class="wxchatBorderRightMid" id="chatRecord" ref="wxchatScrollRef" @scroll="handleScroll">
                    <div ref="chatRecordRef" class="chatRecordBox">
                        <div v-for="(item ,index) in chatRecordNew" :key="index">
                            <el-row v-if="item.css === 'left' && item.type ==1" style="padding-left: 30px;">
                                <el-col :span="1" style="width:52px">
                                    <el-avatar shape="square" :src="targetUserPhoto"
                                                style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </el-col>
                                <el-col :span="20">
                                    <div class="chatPop1">
                                      <p>{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</p>
                                        <span style="white-space: pre-wrap;">{{ item.txt.content }}</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row v-if="item.css === 'left' && item.type == 2" style="padding-left: 30px;">
                                <el-col :span="1" style="width:52px">
                                    <el-avatar shape="square" :src="targetUserPhoto"
                                                style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </el-col>
                                <el-col :span="20">
                                    <div class="chatPop1">
                                      <p>{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</p>
<!--                                        <el-image
                                            :src="item.txt.content?item.txt.content:item.txt.imageUri"
                                            :preview-src-list="item.txt.imageUri.split()">
                                        </el-image>-->
                                        <el-image
                                            :src="item.txt.imageUri"
                                            :preview-src-list="item.txt.imageUri.split()">
                                        </el-image>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row v-if="item.css === 'left' && item.type == 3" style="padding-left: 30px;">
                                <el-col :span="1" style="width:52px">
                                    <el-avatar shape="square" :src="targetUserPhoto"
                                                style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </el-col>
                                <el-col :span="20">
                                    <div class="chatPop1">
                                      <p>{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</p>
                                        <div class="fileContent" style="float: left;margin-left: 10px;">
                                            <div class="img"><i class="iconfont icon-wenjian"></i></div>
                                            <div class="name"><a :href="item.txt.fileUrl" :download="item.txt.name">{{
                                                item.txt.name }}</a></div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row v-if="item.css === 'right' && item.type == 1">
                                <el-col :span="21">
                                    <div class="chatPop2">
                                        <p>{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</p>
                                        <span>{{ item.txt.content }}</span>
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <span>{{ item.headImg }}</span>
                                    <el-avatar shape="square" :src="item.headImg?item.headImg:require('../../assets/users.png')" style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </el-col>
                            </el-row>
                            <el-row v-if="item.css === 'right' && item.type == 2">
                                <el-col :span="21">
                                    <div class="chatPop2">
                                      <p>{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</p>
<!--                                        <el-image
                                            :src="item.txt.content?item.txt.content:item.txt.imageUri"
                                            :preview-src-list="item.txt.imageUri.split()">
                                        </el-image>-->
                                        <el-image
                                            :src="item.txt.imageUri"
                                            :preview-src-list="item.txt.imageUri.split()">
                                        </el-image>
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <el-avatar shape="square" :src="item.headImg?item.headImg:require('../../assets/users.png')" style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </el-col>
                            </el-row>
                            <el-row v-if="item.css === 'right' && item.type == 3">
                                <el-col :span="21">
                                    <div class="chatPop2">
                                        <div class="chatPop1">
                                          <p>{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</p>
                                            <div class="fileContent">
                                                <div class="img"><i class="iconfont icon-wenjian"></i></div>
                                                <div class="name"><a :href="item.txt.fileUrl" :download="item.txt.name">{{
                                                    item.txt.name }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <el-avatar shape="square" :src="item.headImg?item.headImg:require('../../assets/users.png')" style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 空的 -->
                        <el-row v-if="progressFlag">
                            <el-col :span="21">
                                <div class="chatPop2">
                                    <div class="chatPop1">
                                        <p>{{ moment(beforeFiles.placeHoderTime).format('YYYY-MM-DD HH:mm:ss') }}</p>
                                        <div class="fileContent fileContent2">
                                            <div class="img"><i class="iconfont icon-wenjian"></i></div>
                                            <div class="name">{{ beforeFiles.placeHoderName }}</div>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <el-avatar shape="square" :src="chatRecordNew[0].headImg?chatRecordNew[0].headImg:require('../../assets/users.png')" style="width: 52px;height: 52px;border-radius:50%"></el-avatar>
                            </el-col>
                        </el-row>
                         <!-- 进度条 -->
                        <el-progress v-if="progressFlag"  type="circle" :percentage="loadProgress" :width="62" style="position: absolute;right: 130px;bottom: 15px;"></el-progress >
                    </div>
                </div>
                <div class="wxchatBorderRightBottom">
                    <div class="wxchatIconGruop">
                        <div>
                            <el-upload
                                class="wxchatIcon1"
                                action="/service-center/upload/file/single"
                                :show-file-list=false
                                :on-change="handleImageUploaderChange"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                :headers="headers">
                                <i class="el-icon-picture"></i>
                            </el-upload>
                            <el-upload
                                class="wxchatIcon2"
                                action="/service-center/upload/file/single"
                                :show-file-list=false
                                :on-success="handleFileSuccess"
                                :before-upload="beforeFileUpload"
                                :on-progress="handleFileProgress"
                                :headers="headers">
                                <i class="el-icon-folder-remove"></i>
                            </el-upload>
                        </div>

                        <div class="sendButton">
                            <el-button
                                size="mini"
                                @click="sendMsg"
                                circle
                                type="primary"
                                icon="el-icon-position">
                            </el-button>
                        </div>
                        <!--        <div class="wxchatIcon2">
                                <i class="el-icon-folder-remove"></i>
                                </div>-->
                        <!--        <div class="wxchatIcon3">
                                <i class="el-icon-scissors"></i>
                                </div>-->
                        <!--        <div class="wxchatIcon4">
                                <i class="el-icon-chat-dot-round"></i>
                                </div>-->
                    </div>
                    <div class="sendBox">
                        <div>
                            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="" v-model="textarea2"
                                    resize="none" autofocus maxlength="500"
                                    class="textareaScrollbar"
                                    @keydown.native="send">
                            </el-input>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    import {mapMutations, mapState} from "vuex";
    import * as RongIMLib from '@rongcloud/imlib-next'
    import {getRongCloudUser} from "../../utils/interface";
    import moment from "moment";

    export default {
        name: "chatDialog",
        data() {
            return {
                conversationList: [],
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
                },
                imgBase64Array: {},
                squareUrl: 'http://192.168.104.36:8080/static/img/%E5%A4%B4%E5%83%8F1.f22cd6d.jpeg',
                dialogVisible: false,
                userId: '',
                targetUserId: '',
                targetUserName: '',
                targetUserPhoto: '',
                userName: '',
                userPhoto: '',
                input2: '',
                textarea2: '',
                chatRecordNew: [],
                isScroll: false,
                searchIn: '',
                searchData: '',
                progressFlag: false,
                loadProgress: 0,
                beforeFiles: {
                    placeHoderName: '',
                    placeHoderTime: '',
                }
            }
        },
        computed: {
            ...mapState({
                chatRecord: "chatRecord"
            }),
        },
		watch:{
			chatRecord:{
			deep:true, //开启深度监听
			   handler(v){
				 if(this.isScroll){
					 setTimeout(() => {
					     this.isScroll = true
					     let scrollbarEl = this.$refs.wxchatScrollRef
					     scrollbarEl.scrollTop = this.$refs.chatRecordRef.clientHeight
					    this.getConversationList()
					 }, 200)
				 }
			   }
					
			},
		},
        methods: {
            ...mapMutations(["clearChatRecords", "isChattingVuex"]),
            // 时间拆分
            getDate(time){
                let date = time.split("-")
                date = date.map(val => {
                    if(val[0] == "0"){
                        return val = val.slice(1)
                    }else {
                        return val
                    }
                })
                return date.join('/')
            },
            //获取会话列表
            getConversationList() {
                // let that = this;
                let startTime = 0;
                let count = 10;
                let order = 0;
                let existsTarget = false;
                this.isScroll = true;
                RongIMLib.getConversationList({
                    // count: count,
                    startTime: startTime,
                    order: order
                }).then(res => {
                    if (res.code === 0) {
                        if (this.targetUserId === '') {
                            this.targetUserId = res.data[0].targetId;
                          getRongCloudUser(this.targetUserId).then(res => {
                                if (res) {
                                    this.targetUserName = res.name;
                                    this.targetUserPhoto = res.headUrl;
									
                                    this.changeTarget(this.targetUserId, this.targetUserName, this.targetUserPhoto,1,'');
                                    setTimeout(() => {
                                        this.isScroll = true
                                        let scrollbarEl = this.$refs.wxchatScrollRef
                                        scrollbarEl.scrollTop = this.$refs.chatRecordRef.clientHeight
                                    }, 200)
                                }
                            });
                        }
                        this.mesgIndex = res.data.findIndex(item => 
                            item.targetId == this.targetUserId
                        )
                        this.conversationList = [];
                        res.data.forEach((conversation, index) => {
                            if (conversation.targetId === this.targetUserId) {
                                existsTarget = true;
                            }
                          getRongCloudUser(conversation.targetId).then(res => {
                                if (res) {
                                  if(!this.conversationList.find(item => {
                                    return (item.uuid === res.uuid);
                                  })) {
                                    let lastSendTime = moment(conversation.latestMessage.sentTime).format("YYYY-MM-DD");
                                    let now = moment(new Date()).format("YYYY-MM-DD");
                                    res.lastSendTimeLong = conversation.latestMessage.sentTime;
                                    if(lastSendTime === now) {
                                      res.lastUnreadTime = moment(conversation.latestMessage.sentTime).format('HH:mm');
                                    } else {
                                      res.lastUnreadTime = moment(conversation.latestMessage.sentTime).format('YYYY-MM-DD')
                                    }
                                    if(conversation.targetId !== this.targetUserId)
                                    res.unreadMessageCount = conversation.unreadMessageCount;
                                    if(conversation.latestMessage.messageType.indexOf("Txt") != -1) {
                                      res.latestMessage = conversation.latestMessage.content.content;
                                    }
                                    this.conversationList.push(res);
                                    this.conversationList.sort((a, b) => {
                                      return b.lastSendTimeLong - a.lastSendTimeLong
                                    })
                                  }
                                }
                            });
                        });

                      if (!existsTarget) {
                        getRongCloudUser(this.targetUserId).then(res => {
                          if(res) {
                            if(!this.conversationList.find(item => {
                              return (item.uuid === res.uuid);
                            })) {
                              this.conversationList.push(res);
                            }
                          }
                        });
                      }
                    } else {
                        // console.log(res.code, res.msg)
                    }
                })
            },
            //获取历史信息
            getHistoryMessage(targetId) {
                let that = this;
                const conversation = {
                    conversationType: RongIMLib.ConversationType.PRIVATE,
                    targetId: targetId
                }
                RongIMLib.getHistoryMessages(conversation).then(res => {
                    console.log("历史消息",res,conversation)
                    if (res.code === 0) {
                        this.clearChatRecords(targetId);
                        this.chatRecordNew = []
                        res.data.list.forEach(message => {
                            let type = 1;
                            if (message.messageType.indexOf("Img") != -1) {
                                type = 2;
                            }
                            if (message.messageType.indexOf("File") != -1) {
                                type = 3;
                            }
                            if (message.senderUserId == that.userId) {
                                let say = {
                                    type: type,
                                    css: 'right',
                                    txt: message.content,
                                    headImg: that.userPhoto,
                                    timestamp: message.sentTime
                                }
                                that.chatRecord[targetId].push(say);
                            } else {
                                let say = {
                                    type: type,
                                    css: 'left',
                                    txt: message.content,
                                    headImg: that.targetUserPhoto,
                                    timestamp: message.sentTime
                                }
                                that.chatRecord[targetId].push(say);
                            }
                        });
                        this.chatRecordNew = that.chatRecord[targetId]
                        console.log("chatRecordNew",this.chatRecordNew)
                        this.dialogVisible = true;
                        this.$forceUpdate();
                    } else {
                        this.$message.warning('连接失败请刷新后重试！')
                    }
                })
            },
            // 滚动获取历史信息
            getHistoryMessageScroll(targetId, timestamp) {
                let that = this;
                const conversation = {
                    conversationType: RongIMLib.ConversationType.PRIVATE,
                    targetId: targetId
                }
                let options = {
                    timestamp: timestamp ? timestamp : 0
                }
                RongIMLib.getHistoryMessages(conversation, options).then(res => {
                    if (res.code === 0) {
                        if(res.data.list.length > 0){
                            this.isScroll = true
                        } else {
                            this.isScroll = false
                        }
                        for (let i = res.data.list.length - 1; i >= 0; i--) {
                            let message = res.data.list[i];
                            let type = 1;
                            if (message.messageType.indexOf("Img") != -1) {
                                type = 2;
                            }
                            if (message.messageType.indexOf("File") != -1) {
                                type = 3;
                            }
                            if (message.senderUserId == that.userId) {
                                let say = {
                                    type: type,
                                    css: 'right',
                                    txt: message.content,
                                    headImg: that.userPhoto,
                                    timestamp: message.sentTime
                                }
                                that.chatRecord[targetId].unshift(say);
                            } else {
                                let say = {
                                    type: type,
                                    css: 'left',
                                    txt: message.content,
                                    headImg: that.targetUserPhoto,
                                    timestamp: message.sentTime
                                }
                                that.chatRecord[targetId].unshift(say);
                            }
                        }
                        this.chatRecordNew = that.chatRecord[targetId]
                    } else {
                        console.log(res.code, res.msg)
                    }
                }).catch((err)=>{
                    console.log("err",err)
                })
            },
            handleAvatarSuccess(obj, fileList) {
                // 定义消息投送目标会话
                const conversation = {conversationType: RongIMLib.ConversationType.PRIVATE, targetId: this.targetUserId}
                // 实例化待发送消息，RongIMLib.ImageMessage 为内置图片型消息，content为缩略图 base64
                const message = new RongIMLib.ImageMessage({content: '', imageUri: obj.url});
                // 发送
                RongIMLib.sendMessage(conversation, message).then(res => {
                    let say = {
                        type: 2,
                        css: 'right',
                        // txt: this.imgBase64Array,
                        txt: res.data.content,
                        headImg: this.userPhoto
                    }
                    // this.chatRecord[this.targetUserId].push(say)
                    // this.$set(this.chatRecord, this.chatRecord[this.targetUserId], say);
                    this.getHistoryMessage(this.targetUserId);
                    setTimeout(() => {
                        this.isScroll = true
                        let scrollbarEl = this.$refs.wxchatScrollRef
                        scrollbarEl.scrollTop = this.$refs.chatRecordRef.clientHeight
                    }, 200)
                })
            },
            beforeAvatarUpload(file) {
                let fileTypes = ['.jpg', '.png', '.jpeg', '.JPG', '.PNG', '.JPEG']
                let fileName = file.name.lastIndexOf('.')
                const fileNameLen = file.name.length
                const fileTypeName = file.name.substring(fileName, fileNameLen)
                let fileIndex = fileTypes.indexOf(fileTypeName)
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isLt5M) {
                    this.$message.error('上传图片大小不能超过 5MB!');
                }
                if (fileIndex === -1) {
                    this.$alert("只能上传图片格式", "提示", {
                        confirmButtonText: "确定",
                    })
                }
                return fileIndex !== -1 && isLt5M
            },
            beforeFileUpload(file) {
                this.beforeFiles.placeHoderName = file.name
                this.beforeFiles.placeHoderTime = file.lastModified

                let fileTypes = ['.stl', '.obj','.doc','.docx','.ppt','.pptx','.ppts','.xls',
                    '.xlsx','.wps','.pdf','.txt','.rar','.zip','.jpg','.png','.gif','.jpeg','.mp4','.mp3',
                    '.STL', '.OBJ','.DOC','.DOCX','.PPT','.PPTX','.PPTS','.XLS',
                    '.XLSX','.WPS','.PDF','.TXT','.RAR','.ZIP','.JPG','.PNG','.GIF','.JPEG','.MP4','.MP3']
                let fileName = file.name.lastIndexOf('.')
                const fileNameLen = file.name.length
                const fileTypeName = file.name.substring(fileName, fileNameLen)
                let fileIndex = fileTypes.indexOf(fileTypeName)
                const isLt5M = file.size / 1024 / 1024 < 20
                if (fileIndex === -1) {
                    this.$alert("不支持该格式文件上传！", "提示", {
                        confirmButtonText: "确定",
                    })
                }
                if (!isLt5M) {
                    this.$message.error('单次上传文件大小不能超过 20MB!');
                }
                return fileIndex !== -1 && isLt5M;
            },
            uploadCallbacks() {
                return {
                    onProgress: (loaded, total) => {
                        const percent = Math.floor(loaded / total * 100);
                        console.log('已上传: ', percent);
                    },
                    onCompleted: (data) => {
                        this.currentFile = data;
                        this.getFileUrl(data);
                    },
                    onError: (error) => {
                        console.error('上传失败', error);
                    }
                }
            },
            handleFileProgress(event,file,fileList){
                this.progressFlag = true
                this.loadProgress = parseInt(event.percent)
                if(this.loadProgress >= 100){
                    this.loadProgress = 100
                    setTimeout(()=>{
                        this.progressFlag = false

                    },480)
                }
            },
            handleFileSuccess(obj, fileList) {
                // 定义消息投送目标会话
                const conversation = {conversationType: RongIMLib.ConversationType.PRIVATE, targetId: this.targetUserId}
                // 实例化待发送消息，RongIMLib.TextMessage 为内置文本型消息
                const message = new RongIMLib.FileMessage({
                    name: obj.name,
                    size: obj.length,
                    type: obj.mimeType,
                    fileUrl: obj.url
                });
                // 发送
                RongIMLib.sendMessage(conversation, message,this.uploadCallbacks).then(res => {
                    let say = {
                        type: 3,
                        css: 'right',
                        txt: res.data.content,
                        headImg: this.userPhoto
                    }
					// this.targetUserId = 0;
                    // this.chatRecord[this.targetUserId].push(say)
                    // this.$set(this.chatRecord, this.chatRecord[this.targetUserId], say);
                    this.getHistoryMessage(this.targetUserId);
                    setTimeout(() => {
                        this.isScroll = true
                        let scrollbarEl = this.$refs.wxchatScrollRef
                        scrollbarEl.scrollTop = this.$refs.chatRecordRef.clientHeight
                    }, 200)
                })
            },
            handleImageUploaderChange(file) {
                const that = this
                let reader = new FileReader()
                reader.readAsDataURL(file.raw)
                reader.onload = function (event) {
                    let img_base64 = this.result
                    that.imgBase64Array = img_base64
                }
            },
            changeTarget(targetId, targetName, headUrl,index,str) {
                // const that = this;
                this.mesgIndex = index
                this.targetUserId = targetId;
                this.targetUserName = targetName;
                this.targetUserPhoto = headUrl
                this.getHistoryMessage(targetId);
				// this.conversationList.unshift(...this.conversationList.splice(index,1))
				if(str === '发送'){
					this.conversationList.forEach((res,req)=>{
						if(res.uuid === targetId){
                            let chatRecordLength = this.chatRecord[targetId].length-1
							let mess = this.chatRecord[targetId][chatRecordLength].txt.content
							res.latestMessage = mess;
							res.lastUnreadTime = moment(res.sentTime).format('HH:mm');
						}
					})
				}
				// this.getConversationList()
                const conversation = {conversationType: RongIMLib.ConversationType.PRIVATE, targetId: targetId}
                RongIMLib.clearMessagesUnreadStatus(conversation).then(res => {
                  this.removeUnreadCount(targetId);
                  //获取会话未读数
                  const includeMuted = false
                  const conversationTypes = [RongIMLib.ConversationType.PRIVATE]
                  RongIMLib.getTotalUnreadCount(includeMuted, conversationTypes).then(res => {
                    if (res.code === 0) {
                      this.$store.state.unReadMsgCount = res.data;
                    } else {
                      console.log(res.code, res.msg)
                    }
                  }).catch(error => {
                    console.log(error)
                  })
                });

                setTimeout(() => {
                    this.isScroll = true
                    let scrollbarEl = this.$refs.wxchatScrollRef
                    scrollbarEl.scrollTop = this.$refs.chatRecordRef.clientHeight
                }, 200)
            },
            init(userId, userName, userPhoto, targetId, targetUserName, targetUserPhoto) {
              if(userId === targetId) {
                this.$alert('不能与自己聊天！');
                return ;
              }
                this.userId = userId
                this.userName = userName
                this.userPhoto = userPhoto
                this.targetUserId = targetId
                this.targetUserName = targetUserName
                this.targetUserPhoto = targetUserPhoto
                this.isChattingVuex(true);
                // this.initListener();
                // this.connectRongCloud();
                this.getConversationList();
                this.getHistoryMessage(this.targetUserId);
                this.$nextTick(()=>{
                     setTimeout(() => {
                        this.isScroll = true
                        let scrollbarEl = this.$refs.wxchatScrollRef
                        if(scrollbarEl){
                            scrollbarEl.scrollTop =  this.$refs.chatRecordRef.clientHeight
                        }
                    }, 200)
                })
               
            },
            initReply(userId, userName, userPhoto) {
                this.userId = userId
                this.userName = userName
                this.userPhoto = userPhoto
                this.isChattingVuex(true);
                this.getConversationList();
            },
            cancel() {
                this.dialogVisible = false;
                this.targetUserId = '';
                this.isChattingVuex(false);
            },
            send(e) {
              if(!e.shiftKey && e.keyCode == 13) {
                e.cancelBubble = true
                e.stopPropagation()
                e.preventDefault()
                this.sendMsg();
              }
            },
            sendMsg() {
                let that = this
                if(that.textarea2.trim() === '') {
                  that.$message.warning('不能发送空白信息');
                  return false;
                }
                let conversationType = RongIMLib.ConversationType.PRIVATE; // 单聊, 其他会话选择相应的消息类型即可
                let targetId = that.targetUserId // 目标 Id
                // 定义消息投送目标会话
                const conversation = {conversationType: RongIMLib.ConversationType.PRIVATE, targetId: targetId}
                // 实例化待发送消息，RongIMLib.TextMessage 为内置文本型消息
                const message = new RongIMLib.TextMessage({content: that.textarea2})
                // this.getConversationList()
				const onProgress = {
                    onProgress(progress){
                        console.log('progress', progress);
                    },
                    onComplete(fileInfo){
                        console.log('fileInfo', fileInfo);
                    },
                }
                // 发送
                RongIMLib.sendMessage(conversation, message,onProgress).then(res => {
				    this.conversationList.unshift(...this.conversationList.splice(this.mesgIndex,1))
					// if(res.data.content.content !=''){
					// 	that.changeTarget(res.data.targetId,null,null,null,'发送')
					// }
                  // let say = {
                  //     type: 1,
                  //     css: 'right',
                  //     txt: res.data.content,
                  //     headImg: that.userPhoto
                  // }
                  // that.chatRecord[this.targetUserId].push(say)
                  this.getHistoryMessage(this.targetUserId);
                  that.textarea2 = ''
                  setTimeout(() => {
					that.changeTarget(res.data.targetId,this.targetUserName,this.targetUserPhoto,this.mesgIndex,'发送')
                    this.isScroll = true
                    let scrollbarEl = this.$refs.wxchatScrollRef
                    let scrollbarElLeft = this.$refs.chartLeft
                    scrollbarElLeft.scrollTop = 0
                    scrollbarEl.scrollTop = this.$refs.chatRecordRef.clientHeight
                  }, 200)
                })
            },
            // 滚动加载历史消息
            handleScroll() {
                let scrollbarEl = this.$refs.wxchatScrollRef
                if (scrollbarEl.scrollTop <= 0) {
                    if (this.chatRecord[this.targetUserId].length > 0) {
                        if (this.isScroll) {
                            let time = this.chatRecord[this.targetUserId][0].timestamp
                            this.getHistoryMessageScroll(this.targetUserId, time)
                        }
                    }
                }
            },
            // 搜索
            searchName(){
                if(this.searchIn != ''){
                    this.searchData = this.conversationList.filter(item => {
                        return Object.keys(item).some(key=>{
                            return (
                                String(item[key]).toLowerCase().indexOf(this.searchIn) > -1
                            )
                        })
                    })
                }else {
                    this.searchData = this.conversationList
                }
            },
          // 清除未读样式
          removeUnreadCount(targetId) {
              this.conversationList.forEach(conversation => {
                if(conversation.uuid === targetId) {
                  conversation.unreadMessageCount = 0;
                }
              });
          }
        }
    }
</script>

<style lang="less" scoped>
    .wxBox {
        display: flex;
    }
	/deep/.el-avatar>img{
		width: 100%;
	}
    /deep/.el-dialog__wrapper {
        z-index: 9999;
    }
    /deep/.el-dialog {
        width: 1040px;
    }
    .el-dialog__header {
        padding: 20px 20px 10px;
    }
    /deep/.el-dialog__body {
        padding: 0;
    }
    .chatPop1 {
        // text-align: left;
    }

    // .chatPop1 :hover {
    //     background-color: #FAFAFA;
    // }

    .chatPop1 span {
        background-color: #f1f1f1;
        padding: 15px 11px;
        display: inline-block;
        border-radius: 10px;
        margin: 0px 0 10px 10px;
        position: relative;
        // border: 1px solid #E3E3E3;
        max-width: 600px;

    }

    .chatPop1 img {
        background-color: #fff;
        padding: 5px 8px;
        display: inline-block;
        border-radius: 10px;
        margin: 0px 0 10px 10px;
        position: relative;
        border: 1px solid #E3E3E3;
        max-width: 290px;
        width: 200px;
        height: 150px;
    }

    .chatPop1 a {
        background-color: #fff;
        padding: 5px 8px;
        display: inline-block;
        border-radius: 10px;
        margin: 0px 0 10px 10px;
        position: relative;
        border: 1px solid #E3E3E3;
        max-width: 290px;
        cursor: pointer;
    }

    .chatPop1 span::after {
        content: '';
        border: 8px solid #ffffff00;
        border-right: 8px solid #f1f1f1;
        position: absolute;
        top: 8px;
        left: -16px;
        transform: rotateY(2deg);
    }

    .chatPop2 {
        text-align: right;
        /deep/.el-image {
            width: 140px;
            margin-right: 10px;
        }
    }

    // .chatPop2 :hover {
    //     background-color: #2683f5;
    // }

    .chatPop2 span {
        white-space: pre-wrap;
        background-color: #33adad;
        display: inline-block;
        border-radius: 10px;
        position: relative;
        border: 1px solid #E3E3E3;
        float: right;
        color: #fff;
        padding: 15px 11px;
        margin: 0px 15px 10px 10px;
        max-width: 600px;
        text-align: left;

    }

    .chatPop2 img {
        display: inline-block;
        border-radius: 10px;
        margin: 0px 15px 10px 10px;
        position: relative;
        border: 1px solid #E3E3E3;
        max-width: 290px;
        float: right;
        color: #fff;
        width: 200px;
        height: 150px;
    }

    .chatPop2 a {
        background-color: #2683f5;
        padding: 5px 8px;
        display: inline-block;
        border-radius: 10px;
        margin: 0px 15px 10px 10px;
        position: relative;
        border: 1px solid #E3E3E3;
        max-width: 290px;
        float: right;
        color: #fff;
        cursor: pointer;
    }

    .chatPop2 span::after {
        content: '';
        border: 8px solid #ffffff00;
        border-right: 8px solid #33adad;
        position: absolute;
        top: 8px;
        right: -16px;
        transform: rotateY(180deg)
    }

    .custom {
        border: 0px solid blue;
        height: 0;
        height: 622px;
        width: 1200px !important;
        box-shadow: 0px 0px 5px 1px #00000038;
    }

    .wxchatBorder {
        width: 795px;
        height: 570px;
        border: 1px solid red;
        margin-left: -20px;
        margin-top: -59.5px;
    }

    .wxchatBorderLeft {
        width: 361px;
        height: 620px;
        // background-color: #eeebe9;
        background: #fff;
        display: inline-block;
        float: left;
        margin-left: -20px;
        margin-top: -60px;
        flex-shrink: 0;
        overflow-y: auto;
        .conversationClass {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 88px;
            border-bottom: 1px solid #efefef;
            &:hover {
                background-color: #efefef5f
            }
        }
        .wxSearch {
            border: 1px solid #efefef;
            height: 53px;
            border-right: 0;
            line-height: 63px;
            padding-bottom: 10px;
            /deep/.el-input__inner {
                width: 80%;
            }
            /deep/.el-input {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;
            }
            /deep/.el-input__prefix {
                left: 41px;
                top: -9px;
            }


        }
    }

    .wxchatBorderLeft .currentObj {
        // border-left: 4px solid #009999;
        background: #E2E1E0;
        &:hover {
            background: #E2E1E0;
        }
    }
    .wxchatPeopleBox {
        width: 100%;
        .wxchatPeople {
            color: #000000;
            font-size: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            .wxchatPeopleTime {
                margin-right: 16px;
                color: #939393;
                font-size: 12px;
            }
        }
        .wxchatPeopleMess {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
            margin-top: 5px;
            .wxchatPeopleMess_con {
                color: #bdbdbd;
                max-width: 240px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .wxchatPeopleMess_num {
                margin-right: 16px;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                background: #009999;
                color: #fff;
                text-align: center;
                line-height: 22px;
            }

        }
    }
    .wxchatNews {
        color: #999;
        padding-top: 5px;
        font-size: 12px;
    }

    .wxchatName {
        color: #000000;
        font-size: 20px;
        float: left;
        padding-left: 30px;
        padding-top: 20px;
        font-size: 16px;
    }

    .wxchatMore {
        color: #999;
        font-size: 20px;
        float: right;
        margin-right: -15px;
        padding-top: 25px;
    }

    .wxchatBorderRight {
        max-width: 245px;
        height: 670px;
        /*background-color: #000;*/
        /*border: 2 px solid red;*/
        display: inline-block;
        float: right;
        margin-right: -22px;
        /*margin-left: 40 px;*/
        margin-top: -60px;
    }

    .wxchatBorderRightTop {
        width: 700px;
        height: 64px;
        background-color: #fff;
        border-bottom: 1px solid #e7e7e7;
        display: block;
        // float: right;
        margin-right: -20px;
        margin-top: -60px;
        position: relative;
        box-sizing: border-box;
        border: 1px solid #efefef;
        border-bottom: 0;

        .closeButton {
            cursor: pointer;
            position: absolute;
            right: 18px;
            top: 20px;
        }
    }

    .wxchatBorderRightMid {
        width: 700px;
        height: 404px;
        background-color: #fff;
        /*border: 2px solid deeppink;*/
        display: block;
        // float: right;
        margin-right: -20px;
        overflow: auto;
        padding: 10px 0;
        box-sizing: border-box;
        border: 1px solid #efefef;
        border-bottom: 0;

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .chatRecordBox {
            position: relative;
        }
    }

    .wxchatBorderRightBottom {
        width: 700px;
        height: 152px;
        background-color: #fff;
        /*border: 1px solid #eee;*/
        display: block;
        // float: right;
        margin-right: -20px;
        box-sizing: border-box;
        border: 1px solid #efefef;
        border: 1px solid #efefef;

    }

    .wxchatIconGruop {
        line-height: 40px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .sendBox {
        margin: 4px 10px 0;
        .textareaScrollbar /deep/.el-textarea__inner {
            border: none !important;

        }
    }

    .wxchatIcon1 {
        display: inline-block;
        font-size: 20px;
        padding-right: 30px;

    }

    .wxchatIcon2 {
        display: inline-block;
        font-size: 20px;
    }

    .wxchatIcon3 {
        display: inline-block;
        padding: 8px 10px 10px 10px;
        width: 40px;
        height: 40px;
        font-size: 20px;
    }

    .wxchatIcon4 {
        display: inline-block;
        padding: 8px 10px 10px 0px;
        width: 40px;
        height: 40px;
        font-size: 20px;
    }

    .sendButton {
        // float: right;
        // margin-top: 12px;
        margin-right: 17px;
        i {
            font-size: 16px;
        }
    }

    .textareaScrollbar textarea::-webkit-scrollbar-track-piece {
        //滚动条凹槽的颜色，还可以设置边框属性
        /*background-color: #f1f1f1;*/
    }

    .textareaScrollbar textarea::-webkit-scrollbar {
        //滚动条的宽度
        width: 5px;
        height: 5px;
        display: none;
    }

    .textareaScrollbar textarea:hover {
        &::-webkit-scrollbar {
            display: block;
        }
    }

    .textareaScrollbar textarea::-webkit-scrollbar-thumb {
        //滚动条的设置
        background-color: #eeebe9;
        background-clip: padding-box;
        min-height: 28px;
        border-radius: 8px;
    }

    .textareaScrollbar textarea::-webkit-scrollbar-thumb:hover {
        background-color: #a8a8a8;
    }

    #chatRecord:hover {
        &::-webkit-scrollbar {
            display: block;
        }
    }

    #chatRecord::-webkit-scrollbar {
        //滚动条的宽度
        width: 5px;
        height: 5px;
    }

    #chatRecord::-webkit-scrollbar-thumb {
        //滚动条的设置
        background-color: #eeebe9;
        background-clip: padding-box;
        min-height: 28px;
        border-radius: 8px;
    }

    #chatRecord::-webkit-scrollbar-thumb:hover {
        background-color: #a8a8a8;
    }

    .fileContent {
        min-width: 200px;
        height: 60px;
        display: flex;
        align-items: center;
        float: right;
        border: 1px solid #ddd;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 5px 10px;
        background: #fff;
        border-radius: 10px;

        &:hover {
            background: #fff;
        }

        i {
            font-size: 35px;
            padding-right: 5px;
            color: #2683f5;
        }

        a {
            background-color: transparent;
            padding: 0;
            display: block;
            border-radius: 0;
            margin: 0;
            position: relative;
            border: none;
            color: #000;
            cursor: pointer;
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
                background: #fff;
            }
        }
    }
    .fileContent2 {
        background: #e8e8e8;
        opacity: 0.3;
    }
    /deep/.el-progress__text {
        color: #000;
        font-size: 14px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/chat/chatDialog.vue